import { render } from "./Plan.vue?vue&type=template&id=53a9d060&scoped=true"
import script from "./Plan.vue?vue&type=script&lang=js"
export * from "./Plan.vue?vue&type=script&lang=js"

import "./Plan.vue?vue&type=style&index=0&id=53a9d060&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53a9d060"

export default script